(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aquarium-enquiry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aquarium-enquiry')) {
    class AquariumEnquiry extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.js-product');
        this.configuration = this.querySelector('[data-aquarium-configuration]');
        this.productLink = this.querySelector('[data-aquarium-link]');
        if (!this.configuration || !this.productLink) return;
        this.handleVariantChange = (event) => {
          const variantId = event.detail?.variant?.id;
          if (!variantId) return;
          const option = Array.from(this.configuration.options).find((item) => item.dataset.variantId === String(variantId));
          if (option) {
            this.configuration.value = option.value;
            this.updateProductLink();
          }
        };
        this.handleConfigurationChange = () => this.updateProductLink();
        this.section?.addEventListener('on:variant:change', this.handleVariantChange);
        this.configuration.addEventListener('change', this.handleConfigurationChange);
        this.updateProductLink();
      }
      disconnectedCallback() {
        this.section?.removeEventListener('on:variant:change', this.handleVariantChange);
        this.configuration?.removeEventListener('change', this.handleConfigurationChange);
      }
      updateProductLink() {
        const option = this.configuration.options[this.configuration.selectedIndex];
        if (!option?.dataset.variantId) return;
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', option.dataset.variantId);
        this.productLink.value = url.toString();
      }
    }
    customElements.define('aquarium-enquiry', AquariumEnquiry);
  }
  } catch(e) { console.error(e); }
})();

})();
